import { lazy } from 'react';
import marketingPath from 'src/constants/urlPath/crm/marketingPath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';
import { PermissionEn } from '@martech-solution/utils/constants';

const Marketing = lazy(() => import('src/pages/CRM/Marketing'));
const TargetGroup = lazy(() => import('src/pages/CRM/Marketing/TargetGroup'));
const PartnerDataSource = lazy(() => import('src/pages/CRM/Marketing/PartnerDataSource'));
const EventType = lazy(() => import('src/pages/CRM/Marketing/EventType'));
const Event = lazy(() => import('src/pages/CRM/Marketing/Event'));
const EventForm = lazy(() => import('src/pages/CRM/Marketing/Event/EventForm'));
const PartnerStage = lazy(() => import('src/pages/CRM/Marketing/PartnerStage'));
const Criteria = lazy(() => import('src/pages/CRM/Marketing/Criteria'));
const Visitor = lazy(() => import('src/pages/CRM/Marketing/Visitor'));
const VisitorForm = lazy(() => import('src/pages/CRM/Marketing/Visitor/Form'));

const marketingRoutes: RouteType[] = [
  {
    path: marketingPath.marketing,
    Layout: NewLayout,
    Component: Marketing
  },
  //  Partner Data Source
  {
    path: marketingPath.partnerDataSource,
    Layout: NewLayout,
    Component: PartnerDataSource,
    permission: PermissionEn.read
  },
  //  Target Group
  {
    path: marketingPath.targetGroup,
    Layout: NewLayout,
    Component: TargetGroup,
    permission: PermissionEn.read
  },
  // Event type
  {
    path: marketingPath.eventType,
    Layout: NewLayout,
    Component: EventType,
    permission: PermissionEn.read
  },
  // Event
  {
    path: marketingPath.event,
    Layout: NewLayout,
    Component: Event,
    permission: PermissionEn.read
  },
  {
    path: marketingPath.eventAdd,
    Layout: NewLayout,
    Component: EventForm,
    permission: PermissionEn.create
  },
  {
    path: `${marketingPath.eventDetail}/:id`,
    Layout: NewLayout,
    Component: EventForm,
    permission: PermissionEn.viewDetail
  },
  {
    path: `${marketingPath.eventEdit}/:id`,
    Layout: NewLayout,
    Component: EventForm,
    permission: PermissionEn.update
  },
  // PartnerStage
  {
    path: marketingPath.partnerStage,
    Layout: NewLayout,
    Component: PartnerStage,
    permission: PermissionEn.read
  },
  // Criteria
  {
    path: marketingPath.criteria,
    Layout: NewLayout,
    Component: Criteria,
    permission: PermissionEn.read
  },

  // Visitor
  {
    path: marketingPath.visitor,
    Layout: NewLayout,
    Component: Visitor,
    permission: PermissionEn.read
  },
  {
    path: marketingPath.visitorAdd,
    Layout: NewLayout,
    Component: VisitorForm,
    permission: PermissionEn.create
  },
  {
    path: `${marketingPath.visitorDetail}/:id`,
    Layout: NewLayout,
    Component: VisitorForm,
    permission: PermissionEn.viewDetail
  },
  {
    path: `${marketingPath.visitorEdit}/:id`,
    Layout: NewLayout,
    Component: VisitorForm,
    permission: PermissionEn.update
  }
];

export default marketingRoutes;
